import { render, staticRenderFns } from "./PassengerDetailsModal.vue?vue&type=template&id=4881b984&scoped=true&"
import script from "./PassengerDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./PassengerDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PassengerDetailsModal.vue?vue&type=style&index=0&id=4881b984&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881b984",
  null
  
)

export default component.exports